export class CreditCard {

  public id: number;
  public type: string;
  public number: number;
  public expireMonth: number;
  public expireYear: number;
  public cvv: number;

}
